import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class NewsSlider {
    constructor($el) {
        this.$el = $el;
        this.hasSlides = this.$el.find('.news-slider__slide').length > 0;
        this.hasSlidesGroups = this.$el.find('.news-slider__slides-group').length > 0;
        this.mode = this.$el[0].hasAttribute('data-mode') ? this.$el.attr('data-mode') : 'handheld';

        this.options = {
            useSlides: {
                pageDots: false,
                wrapAround: true,
                prevNextButtons: false,
                cellSelector: '.news-slider__slide'
            },
            useSlidesGroups: {
                pageDots: false,
                wrapAround: true,
                prevNextButtons: false,
                draggable: '>3',
                cellSelector: '.news-slider__slides-group'
            }
        };

        if(this.$el.length && this.hasSlides) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        if(this.mode === 'handheld') {
            this.slider = this.$el.flickity(this.options.useSlides);
        }
        else {
            this.slider = this.$el.flickity(this.options.useSlidesGroups);
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.$el.flickity('destroy');
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if((DeviceManager.currentBreakpoint === 'desktop' || DeviceManager.currentBreakpoint === 'desktopLarge') && this.mode !== 'handheld') {console.log('test');
            this._destroy();
            this.slider = this.$el.flickity(this.options.useSlidesGroups);
        }
    }
}

export default NewsSlider;
